<mat-toolbar class="bg-beige-tricon">
    Add Another Applicant
    <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<mat-dialog-content>
    <p>Would you like to complete this applicant’s information yourself or invite him/her to complete the application separately?</p>
</mat-dialog-content>

<mat-dialog-actions class="w-full flex justify-center">
    <div class="flex">
        <button mat-flat-button class="flex" color="primary" mat-dialog-close mat-dialog-close="completeMyself">COMPLETE MYSELF</button>
    </div>
    <div class="flex pt-4">
        <button mat-flat-button class="flex" color="primary" mat-dialog-close mat-dialog-close="sendInvite">SEND AN INVITATION</button>
    </div>
</mat-dialog-actions>